<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
          <h3>{{ campaignDescription.campaign_name }} - Review Data Changes</h3>
        </vs-col>
      </vs-row>


      <template v-for="(changes, k, index) in review_changes">





        <vs-row>
          <vs-col vs-type="flex" vs-w="3" class="pb-5 pt-10">
            <h6 class="mr-5">Company Name : </h6> <a class="hyperlink_class"
              @click="goToReviewDataChangesDetail(changes['account_id'])">{{ 'company_name' in
                changes ? changes['company_name'] : changes['company'] }}</a>
          </vs-col>
          <vs-col vs-type="flex" vs-w="3" class="pb-5 pt-10">
            <h6 class="mr-5" v-if="changes['sales_devloper_name']">Sales Developer : </h6> {{ changes['sales_devloper_name'] }}
          </vs-col>
          <vs-col vs-type="flex" vs-w="2" class="pb-5 pt-10">
            <h6 class="mr-5" v-if="changes['forename']">First Name : </h6> {{ changes['forename'] }}
          </vs-col>
          <vs-col vs-type="flex" vs-w="2" class="pb-5 pt-10">
            <h6 class="mr-5" v-if="changes['surname']">Surname : </h6> {{ changes['surname'] }}
          </vs-col>
          <vs-col vs-type="flex" vs-w="2" class="pb-5 pt-10">
            <h6 class="mr-5" v-if="changes['job_title']">Job Role : </h6> {{ changes['job_title'] }}
          </vs-col>
        </vs-row>
        <vs-row>
          <h4 v-if="changes['data_from'] == 'contact'">Contact Fields </h4>
          <h4 v-else>Account Fields </h4>

        </vs-row>


        <vs-row vs-w="12">
          <vs-col vs-type="flex" vs-w="12">
            <vs-row class="pb-4">
              <vs-col vs-w="4">



                <template v-for="(value, key, index) in changes">

                  <div class="p-6" style="height:auto;"
                    v-if="(selected_account_fields.includes(key)) && changes['field_name'] == key">


                         

                    <template v-for="field_array_column in  changes['campaign_data_options']">

                      

                      <template v-if="field_array_column.column_id == key">

                  
                          {{ field_array_column.name }}


                        </template>
                   </template>

                    <!-- {{ key }} -->
                  </div>
                </template>
              </vs-col>
              <vs-col vs-w="3">
                <template v-for="(value, key, index) in changes">

                  <div class="p-6" style="height:auto;"
                    v-if="(selected_account_fields.includes(key)) && changes['field_name'] == key">
                    
                    <template v-for="field_array_column in  changes['campaign_data_options']">
                      <template v-if="field_array_column.column_id == key">

                        
                  
                        <span v-if="field_array_column.identifier == 'phone'">



                          <template v-if="value != 'EMPTY'">
    
                            <template v-for="v in value">
                              {{ v['phone_code'] }} - {{ v['phone_no'] }} - {{ v['phone_type'] }}
                              <vs-divider class="mt-5" />
    
    
                            </template>
    
    
    
                          </template>
    
                          <template v-else>
    
    
                            {{ value }}
    
    
                          </template>
    
    
    
                        </span>

                        <span v-else-if="field_array_column.identifier == 'ddi'">




                          <template v-if="value != 'EMPTY'">
    
                            <template v-for="v in value">
                              {{ v['ddi_phone_code'] }} - {{ v['ddi'] }} 
                              <vs-divider class="mt-5" />
    
    
                            </template>
    
    
    
                          </template>
    
                          <template v-else>
    
    
                            {{ value }}
    
    
                          </template>
    
    
    
                        </span>

                        <span v-else-if="field_array_column.identifier == 'mobile'">




                          <template v-if="value != 'EMPTY'">
    
                            <template v-for="v in value">
                              {{ v['mobile_phone_code'] }} - {{ v['mobile'] }} 
                              <vs-divider class="mt-5" />
    
    
                            </template>
    
    
    
                          </template>
    
                          <template v-else>
    
    
                            {{ value }}
    
    
                          </template>
    
    
    
                        </span>


                        <span v-else-if="field_array_column.identifier == 'linkedin'">




                          
                          <template v-if="value != 'EMPTY'">
    
                            <template v-for="v in value">
                              {{ v['url'] }}
                              <vs-divider class="mt-5" />
    
    
                            </template>
    
    
    
                          </template>
    
                          <template v-else>
    
    
                            {{ value }}
    
    
                          </template>
    
    
    
                        </span>


                        <span v-else-if="field_array_column.identifier == 'contact_social_media'">




                          
                          <template v-if="value != 'EMPTY'">
             
                            <template v-for="v in value">
                              {{ v['social_media'] }} {{ v['summary'] }}
                              <vs-divider class="mt-5" />
    
    
                            </template>
    
    
    
                          </template>
    
                          <template v-else>
    
    
                            {{ value }}
    
    
                          </template>
    
    
    
                        </span>

                        <span v-else-if="field_array_column.identifier == 'email'">




                          
                          <template v-if="value != 'EMPTY'">
    
                            <template v-for="v in value">
                              {{ v['email'] }}
                              <vs-divider class="mt-5" />
    
    
                            </template>
    
    
    
                          </template>
    
                          <template v-else>
    
    
                            {{ value }}
    
    
                          </template>
    
    
    
                        </span>


                         

                        <span v-else-if="field_array_column.identifier == 'website'">



                      <template v-if="value != 'EMPTY'">



                        <template v-for="v in value">
                          {{ v['url']}}

                          <vs-divider class="mt-5" />


                        </template>



                      </template>

                      <template v-else>


                        {{ value }}


                      </template>



                    </span>
                    <span v-else>




                       <span v-if="key == 'phone_no'">

                        <template v-for="v in value">
                          {{ v['phone_code']}}  - {{ v['phone_no']}} {{ v['phone_type']}}

                          <vs-divider class="mt-5" />


                        </template>
                        
                           
                      </span>
                      <span v-else>

                        <div v-if="field_array_column.type == 'textarea'">




                          <template v-if="Array.isArray(value)">

                            <template v-if="value.length > 0">
                               
                              <div v-html="value"></div>

                              
                            </template>

                            <template v-else>

                              {{ 'EMPTY' }}

                            </template>

                          </template>

                          <template v-else>

                            <div v-html="value"></div>

                          </template>




                        </div>

                        <div v-else>


                          <template v-if="Array.isArray(value)">

                            <template v-if="value.length > 0">
                               
                              {{  value }}
                              
                            </template>

                            <template v-else>

                              {{ 'EMPTY' }}

                            </template>

                          </template>

                          <template v-else>

                            <template v-if="field_array_column.type == 'datetime'">


                             {{ moment().format("YYYY-MM-DD HH:mm") }} 
                              
                            </template>
                            <template v-else>
                              
                              {{  value }}
                            </template>

                            


                          </template>

                          <!-- {{ value }} -->

                          </div>

                        

                      </span>




                      

                    </span>


                        </template>
                   </template>
                    
                    
                   


                    
                   
                  </div>
                </template>
              </vs-col>
              <vs-col vs-w="5">

                <template v-for="(value, key, index) in changes">


                  
                  <div class="p-6" style="height:auto;"
                    v-if="(selected_account_fields.includes(key)) && changes['field_name'] == key">



                    <vs-row>
                      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">


                        <template v-for="(v, n, i) in selected_account_fields_with_details">



                          
                          <template v-if="key == v['column_id']">






                         

                            <div v-if="v['type'] == 'checkbox'" class="width_class">


                              <span v-for="(v, key) in JSON.parse(v.values)">
                                <input type="checkbox" class="ml-4" :checked="changes['field_value'].includes(v.value)"
                                  :value="v.value" v-model="changes['field_value']" />
                                {{ v.value }}
                              </span>

                            </div>
                            <div v-if="v['type'] == 'dropdown'">

                              <v-select class="width_class" v-model="changes['field_value']" label="value"
                                :options="JSON.parse(v.values)" name="type" />

                            </div>

                            <div v-if="v['type'] == 'text' || v['type'] == 'client_contact'">



                              <span v-if="v['identifier'] == 'email'">


                                <template v-for="v in changes['field_value']">

                                  <vs-input class="width_class" v-model="v['email']" />
    
    
    
                                  <br>
                                </template>

                                </span>
                                

                                <span v-else-if="v['identifier'] == 'contact_social_media'">


                                  <template v-for="v in changes['field_value']">




                                    <div class="flex mb-4">
                                      <div class="w-3/4 bg-grid-color-secondary h-12 mr-5">
                                        <vs-input class="width_class" v-model="v['social_media']" />

                                      </div>
                                      <div class="w-3/4 bg-grid-color-secondary h-12 mr-5">
                                        <vs-textarea class="width_class" v-model="v['summary']"/>
                                      </div>
                                    
                                    </div>



  

      
      
      
                                    <br>
                                  </template>
  
                                  </span>

                              <span v-else-if="v['identifier'] == 'linkedin'">


                                <template v-for="v in changes['field_value']">

                                  <vs-input class="width_class" v-model="v['url']" />
    
    
    
                                  <br>
                                </template>

                                </span>

                                <span v-else-if="v['identifier'] == 'website'">


                                  <template v-for="v in changes['field_value']">
  
                                    <vs-input class="width_class" v-model="v['url']" />
      
      
      
                                    <br>
                                  </template>
  
                                  </span>


                                  <span v-else-if="v['identifier'] == 'switchboard_phone_code'">


                                    <v-select name="phone_code" class="phone_code" label="name_with_code"
                                    :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="changes['field_value']" />
    
                                    </span>


                                    <span v-else-if="key == 'account_status'">
                                      <template v-for="v in changes['field_value']">
          
                                        <vs-row vs-w="12">
                                          <vs-col vs-w="4" class="mr-20">


                                            <!-- {{ v }} -->
          

          
          
                                            <v-select style="width:250px;" @input="fetchAccountSDSubStatusByStatusIDAndRoleID(v.account_status.id , changes['id'])" name="account_status" label="status"
                                              :options="all_account_status" v-model="v['account_status']" />

                                              

                                                 <div class="vx-col w-full mt-5" v-if="v['all_account_sub_status'].length > 0">
                                                          <template v-for="sub_status in v['all_account_sub_status']">
                                                              <input 
                                                                v-validate="'required'"
                                                                data-vv-as="Sub Status"
                                                                name="sub_status"
                                                                v-model="v['account_sub_status']"
                                                                :value="sub_status"
                                                                type="checkbox">
                                                              <span class="ml-2"> {{ sub_status.sub_status }} </span> 


                                                            </br>
                                                    </template>
             
             
            </div>



                                              
          
          
                                          </vs-col>
                                          <vs-col vs-w="6">
          
                                            <vs-textarea class="width_class" v-model="v['account_status_notes']"></vs-textarea>
                                          </vs-col>
                                        </vs-row>
          
          
          
                                        <br>
                                      </template>
          
                                    </span>

                                    <span v-else-if="key == 'contact_status'">

                                      <template v-for="v in changes['field_value']">
          
                                        <vs-row vs-w="12">
                                          <vs-col vs-w="4" class="mr-20">
          
          
          
                                            <v-select style="width:250px;" @input="fetchContactSDSubStatusByStatusIDAndRoleID(v.contact_status.id , changes['id'])" name="contact_status" label="status"
                                              :options="all_account_status" v-model="v['contact_status']" />


                                                                            <div class="vx-col w-full mt-5" v-if="v['all_contact_sub_status'].length > 0">
                                                          <template v-for="sub_status in v['all_contact_sub_status']">
                                                              <input 
                                                                v-validate="'required'"
                                                                data-vv-as="Sub Status"
                                                                name="sub_status"
                                                                v-model="v['contact_sub_status']"
                                                                :value="sub_status"
                                                                type="checkbox">
                                                              <span class="ml-2"> {{ sub_status.sub_status }} </span> 


                                                            </br>
                                                    </template>
             
             
            </div>
          
          
                                          </vs-col>
                                          <vs-col vs-w="6">
          
                                            <vs-textarea class="width_class" v-model="v['contact_status_notes']"></vs-textarea>
                                          </vs-col>
                                        </vs-row>
          
          
          
                                        <br>
                                      </template>
          
                                    </span>


                              


                                  <span v-else-if="v['identifier'] == 'phone'">


                                    <template v-for="v in changes['field_value']">

                                      <vs-row vs-w="12">
                                        <vs-col vs-w="3" class="mr-5">
                                          <v-select name="phone_code" class="phone_code" label="name_with_code"
                                            :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="v['phone_code']" />
        
                                        </vs-col>
        
        
                                        <vs-col vs-w="3" class="mr-5">
                                          <vs-input v-model="v['phone_no']" />
        
                                        </vs-col>
                                        <vs-col vs-w="3">
                                          <v-select label="slug" style="width:300px;" :options="phoneTypes"
                                            :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="v['phone_type']" />
                                        </vs-col>
                                      </vs-row>
        
        
        
                                      <br>
                                    </template>
    
                                    </span>



                                    <span v-else-if="v['identifier'] == 'ddi'">


                                      <template v-for="v in changes['field_value']">
  
                                        <vs-row vs-w="12">
                                          <vs-col vs-w="3" class="mr-5">
                                            <v-select name="ddi_phone_code" class="ddi_phone_code" label="name_with_code"
                                              :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="v['ddi_phone_code']" />
          
                                          </vs-col>
          
          
                                          <vs-col vs-w="3" class="mr-5">
                                            <vs-input v-model="v['ddi']" />
          
                                          </vs-col>
                                        
                                        </vs-row>
          
          
          
                                        <br>
                                      </template>
      
                                      </span>


                                      <span v-else-if="v['identifier'] == 'mobile'">


                                        <template v-for="v in changes['field_value']">
    
                                          <vs-row vs-w="12">
                                            <vs-col vs-w="3" class="mr-5">
                                              <v-select name="mobile_phone_code" class="mobile_phone_code" label="name_with_code"
                                                :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="v['mobile_phone_code']" />
            
                                            </vs-col>
            
            
                                            <vs-col vs-w="3" class="mr-5">
                                              <vs-input v-model="v['mobile']" />
            
                                            </vs-col>
                                          
                                          </vs-row>
            
            
            
                                          <br>
                                        </template>
        
                                        </span>



                                <span v-else>

                                  <template v-if="v['identifier'] == 'registered_office_country'">

                                    <v-select name="registered_office_country" class="width_class" label="name_1"
                                    :options="all_countries" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="changes['field_value']" />
                                   </template>

                                     <template v-else-if="v['identifier'] == 'parent'">

                                      {{ changes['field_value'] }}

              <AccountAutocomplete ref="EditAccountParentRef" class="searchbox" :list="getParentCompany"
                :searchOn="'parent'">
              </AccountAutocomplete>


                    <!-- <v-select name="parent" class="parent" label="name_1"
                    :options="all_countries" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="all_field_datas[key]" /> -->
                   </template>

                                   <template v-else-if="v['identifier'] == 'head_office_country'">

                                    <v-select name="head_office_country" class="width_class" label="name_1"
                                    :options="all_countries" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="changes['field_value']" />
                                   </template>

                                   <template v-else-if="v['identifier'] == 'registration_jurisdiction'">

                                    <v-select name="registration_jurisdiction" class="width_class" label="name_1"
                                    :options="all_countries" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="changes['field_value']" />
                                   </template>

                                   <template v-else-if="v['identifier'] == 'vertical'">

                                    <v-select name="registration_jurisdiction" class="width_class" label="name_1"
                                    :options="all_verticals" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="changes['field_value']" />
                                   </template>


                                   <template v-else>
                                      <vs-input name="text" class="width_class" v-model="changes['field_value']" />
                                   </template>
                  
                                </span>





                            </div>
                            <div v-if="v['type'] == 'number'">

                              <input type="number" 
                              class="vs-input-class" v-model="changes['field_value']"  name="text"/>


                            </div>
                            <div v-if="v['type'] == 'textarea'">




                              <div :class="'textarea' + changes['field_name']">

                                <vue-trumbowyg v-model="changes['field_value']" 
                                :config="configs.basic"></vue-trumbowyg>

                              </div>

                             


                            </div>
                            <div v-if="v['type'] == 'date'">
                              <flat-pickr class="width_class" :config="configDateTimePicker" placeholder="Choose Date"
                                name="continuous_date_end" v-model="changes['field_value']" />

                            </div>
                            <div v-if="v['type'] == 'datetime'">
                              <flat-pickr class="width_class" :config="configDateAndTimePicker" placeholder="Choose Date And Time"
                                name="continuous_date_and_time" v-model="changes['field_value']" />

                            </div>

                            <div v-if="v['type'] == 'choose_one'" class="width_class">

                              <span v-for="val, k in JSON.parse(v['values'])">

                                <input class="ml-4" :value="val.value" type="radio" v-model="changes['field_value']" />
                                {{ val.value }}
                              </span>

                            </div>
                          </template>
                        </template>


                   










                      </vs-col>
                      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                        <feather-icon @click="reviewerAccepted(changes)" icon="CheckIcon" class="accept-button mr-5" />
                        <feather-icon @click="reviewerRejected(changes)" class="accept-button mr-5" icon="DeleteIcon" />
                      </vs-col>
                    </vs-row>

                  </div>
                </template>

               
              </vs-col>
            </vs-row>
          </vs-col>

       
          
        </vs-row>
        <vs-divider class="mt-5" />

      </template>

    </vx-card>

  </div>
</template>

<script>
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import moduleGradeManagement from "@/store/grade-management/moduleGradeManagement.js";
import moduleSDSubStatusManagement from "@/store/sd-sub-status-management/moduleSDSubStatusManagement.js";
import AccountAutocomplete from '@/components/autocomplete/AccountsAutocomplete.vue'
import VueTrumbowyg  from 'vue-trumbowyg';
import 'jquery-resizable-dom/dist/jquery-resizable.js';
import 'jquery-resizable-dom/dist/jquery-resizableTableColumns.js';
import moment from 'moment';
import 'trumbowyg/dist/trumbowyg.min.js';
import 'trumbowyg/dist/ui/trumbowyg.min.css';
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css';
import 'trumbowyg/dist/plugins/table/trumbowyg.table.min.js';
import 'trumbowyg/dist/plugins/table/ui/trumbowyg.table.min.css';
import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js';
import 'trumbowyg/dist/plugins/upload/trumbowyg.upload.min.js';
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.min.js'
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css'
import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min.js'
import 'trumbowyg/dist/plugins/preformatted/trumbowyg.preformatted.min.js'
import 'trumbowyg/dist/plugins/lineheight/trumbowyg.lineheight.min.js'
import 'trumbowyg/dist/plugins/indent/trumbowyg.indent.min.js'
import 'trumbowyg/dist/plugins/resizimg/trumbowyg.resizimg.js'

export default {
  data: () => ({
      user_role_id: null,
      sub_statuses: [],
    moment: moment,
    configs: {
          basic: {
            autogrow: true,
            removeformatPasted: true,
                btns: [
                    ['strong', 'em'],
                    ['superscript', 'subscript'],
                    ['fontsize'],
                    ['foreColor', 'backColor'],
                    ['link'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['horizontalRule'],
                    ['removeformat'],
                    ['fullscreen']
                ],
                plugins: {
                    table: {
                        columns: 10,
                        rows: 10,
                    
                    },
                    resizimg: {
            minSize: 64,
            step: 16,
        }

                    }
                        }
      },
    all_countries : [],
    all_phone_codes: [],
    all_account_status: [],
    all_contact_status: [],
    opportunity_owner_value: null,
    search: '',
    toggle: false,
    campaign_client_contacts: [],
    newCampaignClientContacts: [],
    phoneTypes: [],
    grade_options: [],
    checkedFields: [],
    user_id: null,
    abilities: null,
    selected_campaign: null,
    campaignDescription: [],
    review_changes: null,
    account_contact_details: [],
    selected_account_fields: [],
    selected_account_fields_with_details: [],
    configDateAndTimePicker: {
      enableTime: true,
      dateFormat: "Y-m-d H:i:s",
      enableSeconds : true
    },
    configDateTimePicker: {
      enableTime: false,
      dateFormat: "Y-m-d"
    },
  }),
  components: {
    "v-select": vSelect,
    flatPickr,
    quillEditor,
    VueTrumbowyg,
    moduleSDSubStatusManagement,
        AccountAutocomplete,

  },
  watch: {
   
  },
  methods: {
        getParentCompany (inputValue) {
      return this.$store
        .dispatch('accountsManagement/searchAutocomplete', inputValue)
        .then(response => {
          let data = JSON.parse(JSON.parse(JSON.stringify(response.data)))
          let mappedArray = []
          for (const property in data) {
            mappedArray.push({
              id: data[property].uuid,
              name: data[property].company_name
            })
          }
          return mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    fetchAccountSDSubStatusByStatusIDAndRoleID(status_id, id) {
      let self = this;
      this.$store
        .dispatch("SDSubStatusManagement/fetchSDSubStatusByStatusIDForReview", {
          status_id: status_id,
          role_id: this.user_role_id,
          level : 'account'
        })
        .then(res => {
          let result = res.data;
          self.sub_statuses = result;

          self.review_changes.forEach(function (e) {

            


            if (e.id == id) {
              e.field_value.forEach(function (m) {



            
                  m.all_account_sub_status = []
                m.all_account_sub_status = self.sub_statuses


              

              })
            }
          })


          // console.log("SUB STATUSSSS" , self.sub_statuses)
          // console.log("ID" , id)

  



        })
        .catch(err => {
          console.error(err);
        });
    },
       fetchContactSDSubStatusByStatusIDAndRoleID(status_id, id) {
      let self = this;
      this.$store
        .dispatch("SDSubStatusManagement/fetchSDSubStatusByStatusIDForReview", {
          status_id: status_id,
          role_id: this.user_role_id,
                    level : 'contact'

        })
        .then(res => {
          let result = res.data;
          self.sub_statuses = result;




          self.review_changes.forEach(function (e) {
            if (e.id == id) {
              e.field_value.forEach(function (m) {




                m.all_contact_sub_status = []
                m.all_contact_sub_status = self.sub_statuses



              })
            }
          })


          // console.log("SUB STATUSSSS" , self.sub_statuses)
          // console.log("ID" , id)

  



        })
        .catch(err => {
          console.error(err);
        });
    },
    fetchAllSDStatus() {
      this.$store
        .dispatch(
          "campaignsManagement/fetchAllSDStatus"
        )
        .then(res => {
          let result = res.data;
          this.all_account_status = result;
        })
        .catch(err => {
          console.error(err);
        });
    },
    updateInput(index, val) {
      let self = this
      self.newCampaignClientContacts[index] = [];
      self.campaign_client_contacts.forEach(element => {
        if (element.full_name.includes(val) && val != "") {
          self.newCampaignClientContacts[index].push(element);
        }
      });

      self.toggle = false
      self.toggle = true
      console.log(self.newCampaignClientContacts[index])

    },
    selectResult(index, client_contact, changes) {
      let self = this
      self.search = client_contact.full_name;
      let dataObj = {}
      dataObj.full_name = client_contact.full_name
      dataObj.id = client_contact.uuid
      self.opportunity_owner_value = dataObj

      for (const property in changes) {

        if (changes[property] == "opportunity_owner") {
          changes['field_value'][0] = dataObj
        }
      }

      // console.log(dataObj)

      // this.$refs[index][0].value = self.search



      self.toggle = false

    },
    goToReviewDataChangesDetail(account_id) {
      this.$router.push({
        path: "/quality_control/review_data/account_detail/" + account_id + "/" + this.$route.params.campaignId + "/" + this.$route.params.campaignName
      });
    },
    updatePrimaryMobile(v, changes, field_name) {

      this.review_changes.forEach(function (e) {
        if (e.account_id == changes.account_id && e.field_name == field_name) {

          e.field_value.forEach(function (m) {
            m.is_primary = 'false'

            if (m.mobile == v.mobile) {
              m.is_primary = 'true'
            }
          })



        }
      })
    },
    updatePrimaryDdi(v, changes, field_name) {

      this.review_changes.forEach(function (e) {
        if (e.account_id == changes.account_id && e.field_name == field_name) {

          e.field_value.forEach(function (m) {
            m.is_primary = 'false'

            if (m.ddi == v.ddi) {
              m.is_primary = 'true'
            }
          })



        }
      })
    },
    updatePrimaryEmail(v, changes, field_name) {

      this.review_changes.forEach(function (e) {
        if (e.account_id == changes.account_id && e.field_name == field_name) {

          e.field_value.forEach(function (m) {
            m.is_primary = 'false'

            if (m.email == v.email) {
              m.is_primary = 'true'
            }
          })



        }
      })
    }, updatePrimarySocialMedia(v, changes, field_name) {

      this.review_changes.forEach(function (e) {
        if (e.account_id == changes.account_id && e.field_name == field_name) {

          e.field_value.forEach(function (m) {
            m.is_primary = 'false'

            if (m.social_media == v.social_media) {
              m.is_primary = 'true'
            }
          })



        }
      })
    },
    getPhoneTypes() {
      this.$store
        .dispatch("accountsManagement/getPhoneTypes")
        .then(res => {
          this.phoneTypes = res.data;
          this.phoneTypes = this.phoneTypes.filter(
            item => item.slug != "head_office_switchboard" && item.slug != "site_switchboard"
          );
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getAllPhoneCodes() {
      let self = this
      this.$store
        .dispatch("accountsManagement/getAllPhoneCodes")
        .then(response => {
          self.all_phone_codes = response.data
          self.all_countries = response.data
          self.all_phone_codes.forEach(function (ele) {
            if (ele.phone_code) {
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getAllGradesByCampaignId() {
      this.$store
        .dispatch("GradesManagement/getAllGradesByCampaignId", this.$route.params.campaignId)
        .then(res => {
          this.grade_options = res.data;
          this.grade_options.sort((a, b) => a.grade - b.grade);

        })
        .catch(err => {
          console.error(err);
        });
    },
    reviewerAccepted(changes) {


      let self = this;
      self.$vs.loading()

      let data = {};
      data.uuid = changes['uuid'];
      data.reviewer_id = self.user_id
      data.changes = changes

      if (moduleAccountsManagement.autocomplete_selected) {
         if (changes['field_name'] == '_c0271cae_1c5a_4da6_8b37_4a3a19e31f93') {
            data.changes.field_value = moduleAccountsManagement.autocomplete_selected.name
         }
      }



      this.$store
        .dispatch("campaignsManagement/reviewerAccepted", data)
        .then(res => {
          if (res.data.status == "success") {


            this.$vs.notify({
              color: "success",
              title: "Data Changes",
              text: res.data.message
            });



         //  this.$router.go()
            this.getCampaignReviewChanges()

          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    reviewerRejected(changes) {
      let self = this;


      let data = {};
      data.uuid = changes['uuid'];
      data.reviewer_id = self.user_id
      data.changes = changes
      this.$store
        .dispatch("campaignsManagement/reviewerRejected", data)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Data Changes",
              text: res.data.message
            });
            // this.$router.go()


            this.getCampaignReviewChanges()

          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    //   let self = this;
    //   let selected_campaign_id = this.$route.params.campaignId;
    //   self.$store
    //     .dispatch(
    //       "campaignsManagement/getSelectedAccountCoreFields",
    //       selected_campaign_id
    //     )
    //     .then(response => {
    //       // let result = JSON.parse(response.data);
    //       // let selected_core_column = JSON.parse(result[0]['selected_column'])
    //       // self.selected_account_core_fields = selected_core_column
    //       // let new_fields = ['phone_no', 'url', 'url', 'account_status']
    //       // self.selected_account_core_fields = self.selected_account_core_fields.concat(new_fields);


    //       self.selected_account_core_fields = JSON.parse(response.data);

    //     })
    //     .catch(err => {
    //       console.error(err);
    //     });
    // },
    // getSelectedContactCoreFields() {
    //   let self = this;
    //   let selected_campaign_id = this.$route.params.campaignId;
    //   self.$store
    //     .dispatch(
    //       "campaignsManagement/getSelectedContactCoreFields",
    //       selected_campaign_id
    //     )
    //     .then(response => {

    //       console.log(JSON.parse(response.data))

    //       self.selected_contact_core_fields = JSON.parse(response.data)


    //       // let result = JSON.parse(response.data);
    //       // let selected_core_column = JSON.parse(result[0]['selected_column'])
    //       // self.selected_contact_core_fields = selected_core_column
    //       // let new_fields = ['contact_ddi', 'contact_email', 'contact_mobile', 'contact_social_media', 'contact_status']
    //       // self.selected_contact_core_fields = self.selected_contact_core_fields.concat(new_fields);

    //     })
    // },
    getSelectedAccountFields() {
      let self = this;
      let data = {}
      data.id = this.$route.params.campaignId;
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedAccountFields",
          data
        )
        .then(response => {
          let result = JSON.parse(response.data);



          let account_fields = []
          result.forEach(function (ele) {
            let column_id = '_' + ele.uuid.replaceAll('-', '_')
            account_fields.push(column_id)
          })



          self.selected_account_fields = account_fields


          console.log("RSULT" , self.selected_account_fields)

        })
        .catch(err => {
         console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
  
 
 
    getSelectedAccountFieldsWithDetails() {
      let self = this;
      let data = {}
      data.id = this.$route.params.campaignId;
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedAccountFieldsWithDetails",
          data
        )
        .then(response => {
          let result = JSON.parse(response.data);
          self.selected_account_fields_with_details = result


          let account_fields = []
          result.forEach(function (ele) {
            account_fields.push(ele.column_id)
          })
          self.selected_account_fields = account_fields
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    goToReviewQualityControlPage(data) {
      this.$router.push({
        path: "/quality_control/account_data/" + data.uuid + '/' + btoa(data.campaign_name)
      });
    },
    goToQualityControlAccounts(data) {
      this.$router.push({
        path: "/quality_control/account_data/" + data.uuid + '/' + btoa(data.campaign_name)
      });
      // console.log(data)
      // this.$router.replace("/sales-developer-dashboard/view/" + this.selected_campaign.campaign_id + '/' + btoa(this.selected_campaign.campaign_name));
      //  alert("got to")
    },
    goToQualityControlContacts(data) {
      this.$router.push({
        path: "/quality_control/contact_data/" + data.uuid + '/' + btoa(data.campaign_name)
      });

      // this.$router.replace("/sales-developer-dashboard/view/" + this.selected_campaign.campaign_id + '/' + btoa(this.selected_campaign.campaign_name));
      //  alert("got to")
    },
    getCampaignDescription() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    },
    getAccountContactDetails() {
      let self = this
      let data = {}
      data.campaign_id = this.$route.params.campaignId
      data.campaign_name = atob(this.$route.params.campaignName)
      this.$store
        .dispatch("campaignsManagement/getCampaignReviewChanges", data)
        .then(res => {
          self.account_contact_details = res.data

        })
        .catch(err => {
          console.error(err);
        });
    },
    getCampaignReviewChanges() {
      let self = this
      let data = {}

      this.$vs.loading()

      data.campaign_id = this.$route.params.campaignId
      data.campaign_name = atob(this.$route.params.campaignName)
      this.$store
        .dispatch("campaignsManagement/getCampaignReviewChanges", data)
        .then(res => {

          this.review_changes = res.data;


          // this.review_changes = this.review_changes.filter(ele => ele.field_name != 'grade')



          this.review_changes.forEach(function (el) {

            el.campaign_id = self.$route.params.campaignId



            Object.keys(el).forEach((key) => {







                if (typeof el[key] === 'string' || el[key] instanceof String) {




                  if (el[key].startsWith('[[') && el[key] != '[[]]') {
                    el[key] =  el[key].slice(1,-1);

     

}


                    if (el[key].startsWith('[') && el[key] != '[]') {


                      el[key] = JSON.parse(el[key])

                      el[key] = [... new Set(el[key])]


                   
                      






                      









                  }





                }

              









              if (el[key] == null || el[key] == '' || el[key] == '[]') {
                if (key != 'reviewer_accepted' && key != 'reviewer_id' && key != 'updated' && key != 'forename' && key != 'surname' && key != 'job_title') {
                  el[key] = []
                }
              }



            });

          })

          self.$vs.loading.close()


          console.log("REVIEW CHANGES" , this.review_changes)



       


        })
        .catch(err => {
          console.error(err);
        });
    },
    firstLast(arr) {
      if (arr.length < 2) return arr;
      return [arr[0], arr[arr.length - 1]];
    },
    goBack: function () {
      this.$router.go(-1);
    }
  },
  beforeMount() {
  },
  mounted() {
    this.fetchAllSDStatus()
    this.getPhoneTypes()
    this.getCampaignDescription()
    // this.getSelectedAccountFields()
    this.getSelectedAccountFieldsWithDetails()
    // this.getSelectedAccountCoreFields()
    // this.getSelectedContactCoreFields()
    this.getCampaignReviewChanges()
    this.getAllGradesByCampaignId()
    this.getAllPhoneCodes()

  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    self.user_id = userInfo["uid"];
    self.user_role_id = 'affbe5ee-3fe7-4cdb-837a-908592475006' // userInfo['role_id']
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
    

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }

     if (!moduleSDSubStatusManagement.isRegistered) {
      this.$store.registerModule("SDSubStatusManagement", moduleSDSubStatusManagement);
      moduleSDSubStatusManagement.isRegistered = true;
    }


    if (!moduleGradeManagement.isRegistered) {
      this.$store.registerModule("GradesManagement", moduleGradeManagement);
      moduleGradeManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.social_media_radio {
  width: auto;
}

.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}


.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.accept-button {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}

.width_class {
  /* max-width: 400px; */
  width: 300px;
}

.imput_field {
  width: 500px;
}

.hyperlink_class {
  cursor: pointer;
}

.vs-input-class{
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.2);
  font-size: 1rem;
  height: 38px;
  padding-left: 10px;
  padding-right: -10px;
  border-radius: 4px;
  background: transparent;
  transition: all .2s ease;


}



.dropdown_class {
  border: 1px solid transparent;
  margin: 4px 0 0 0;
  padding: 0 7px;
  background: none;
  box-shadow: none;
  width: 500px;
  background: none;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
  position: relative;
  font-family: inherit;
  height: 35px;
}

.ql-class {
  width: auto;
}

#text_box {
  display: none;
}


</style>

<style lang="stylus">
.inputx
  margin-left 20px
  margin-top 10px



.con-expand-Fields
  .con-btns-Fields
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Fieldsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
